import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import PublicLayout, { PageHero } from "../../components/PublicLayout";
import { useLang } from "../../context/LanguageContext";

const Item = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <button onClick={() => setOpen(!open)} className="w-full text-left rounded-2xl border border-[#2A2A2A] bg-[#181818] p-5 hover:border-[#3a3a3d] transition-colors">
      <div className="flex items-center justify-between gap-4"><span className="text-white font-medium text-[16px]">{q}</span><ChevronDown size={20} className={`text-neutral-500 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} /></div>
      {open && <p className="text-[15px] text-neutral-400 leading-relaxed mt-3">{a}</p>}
    </button>
  );
};

const FAQ = () => {
  const { t } = useLang();
  const items = t("pages.faq.items");
  return (
    <PublicLayout>
      <PageHero eyebrow={t("pages.faq.eyebrow")} title={t("pages.faq.title")} subtitle={t("pages.faq.subtitle")} />
      <section className="max-w-[760px] mx-auto px-6 pb-24 space-y-3">
        {items.map((f) => <Item key={f.q} {...f} />)}
      </section>
    </PublicLayout>
  );
};

export default FAQ;
